"use client";
import { Clock, MapPin, Calendar, CarFront } from "lucide-react";

interface QuickInfoSectionProps {
  duration?: string;
  distance?: string;
  bestTime?: string;
  travelTime?: string;
}

export default function QuickInfoSection({
  duration,
  distance,
  bestTime,
  travelTime,
}: QuickInfoSectionProps) {
  return (
    <section className="py-16 bg-[#F9F7F4]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {duration && (
            <div className="bg-white rounded-xl p-6 text-center">
              <Clock className="h-8 w-8 text-[#B42025] mx-auto mb-3" />
              <p className="text-sm text-gray-500 mb-1">Duration</p>
              <p className="text-gray-900 font-medium">{duration}</p>
            </div>
          )}
          {distance && (
            <div className="bg-white rounded-xl p-6 text-center">
              <MapPin className="h-8 w-8 text-[#B42025] mx-auto mb-3" />
              <p className="text-sm text-gray-500 mb-1">Distance</p>
              <p className="text-gray-900 font-medium">{distance}</p>
            </div>
          )}
          {bestTime && (
            <div className="bg-white rounded-xl p-6 text-center">
              <Calendar className="h-8 w-8 text-[#B42025] mx-auto mb-3" />
              <p className="text-sm text-gray-500 mb-1">Best Time</p>
              <p className="text-gray-900 font-medium">{bestTime}</p>
            </div>
          )}
          {travelTime && (
            <div className="bg-white rounded-xl p-6 text-center">
              <CarFront className="h-8 w-8 text-[#B42025] mx-auto mb-3" />
              <p className="text-sm text-gray-500 mb-1">Travel Time</p>
              <p className="text-gray-900 font-medium">{travelTime}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
